var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"calc(100% - 455px)"}},_vm._l((_vm.blogList),function(item,index){return _c('div',{key:index},[_c('BlogItem',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('el-main',[_c('BlogTagWidget'),_vm._v(" "),_c('el-calendar')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84eab364","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/pages/blog/Blog.vue
// module id = null
// module chunks = 